import { fetchUserAttributes } from "@aws-amplify/auth";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchUserStatus = createAsyncThunk(
  "auth/fetchUserStatus",
  async () => {
    const res = await fetchUserAttributes();
    return res;
  }
);
